export default {"src":"/_next/static/media/facebook-vector-logo.184ef155.svg","height":30,"width":110,"blurWidth":0,"blurHeight":0};